import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App.tsx";
import { config } from "./config/config.ts";
import "./config/init-i18n.ts";
import { PraxisProvider } from "./praxis-config/praxis-context.tsx";
import { AppErrorPage } from "./components/app-error-page.tsx";

Sentry.init({
  dsn: config.SENTRY_DSN,
  environment: config.ENVIRONMENT,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary
      FallbackComponent={AppErrorPage}
      onError={(error) => {
        Sentry.captureException(error);
      }}
    >
      <PraxisProvider>
        <App />
      </PraxisProvider>
    </ErrorBoundary>
  </StrictMode>,
);
